import React, { useState } from 'react';
import { Popover, Button, Select, Icon, Radio } from 'antd';

const { Option } = Select;

const getPriorityCountries = (countries) => {
  let arrayState = [];

  if (countries && countries.length) {
    countries.forEach((country) => {
      if (country.priority) {
        arrayState.push(country);
      }
    });
  }

  return arrayState;
};

export const NonVerifiedCountry = ({
  onChange,
  onChangeDefine,
  countries = [],
  params
}) => {
  const [isPriorityCountry, setIsPriorityCountry] = useState(true);

  const changeSort = () => {
    let order;

    if (params?.order === '') {
      order = 'asc';
    } else if (params?.order === 'asc') {
      order = 'desc';
    } else {
      order = '';
    }

    onChange({ ...params, order });
  };

  const content = (
    <>
      <div style={{ marginBottom: 8 }} onClick={changeSort}>
        <b style={{ marginRight: 5 }}>Sort:</b>
        {!params?.order && <Icon type='column-height' />}
        {params?.order === 'asc' && <Icon type='sort-ascending' />}
        {params?.order === 'desc' && <Icon type='sort-descending' />}
      </div>
      {/* <div style={{ marginBottom: 8 }}>
        <Checkbox
          onChange={(e) => {
            if (e.target.checked) {
              setIsPriorityCountry(true);
            } else {
              setIsPriorityCountry(false);
            }
          }}
          defaultChecked
        >
          Priority Countries
        </Checkbox>
      </div>

      <div style={{ marginBottom: 8 }}>
        <Checkbox
          checked={isUndefineCountry}
          onChange={(e) => {
            if (e.target.checked) {
              onChangeDefine(true);
            } else {
              onChangeDefine(false);
            }
          }}
        >
          No Country Defined
        </Checkbox>
      </div> */}

      <Radio.Group
        style={{ display: 'flex', flexDirection: 'column', marginBottom: 8 }}
        onChange={onChangeDefine}
      >
        <Radio
          value='priority'
          style={{ marginRight: '1rem' }}
          onClick={() => setIsPriorityCountry(true)}
        >
          Priority Countries
        </Radio>
        <Radio
          value='undefineNonCountry'
          style={{ marginRight: '1rem' }}
          onClick={() => setIsPriorityCountry(false)}
        >
          No Country Defined
        </Radio>
      </Radio.Group>

      <Select
        value={params?.value}
        mode='multiple'
        style={{ width: 180, marginRight: '10px' }}
        allowClear
        placeholder='Non-verified country'
        onChange={(value) => {
          onChange({ ...params, value });
        }}
      >
        {!isPriorityCountry
          ? countries.map((country) => (
              <Option key={country.alpha3Code} value={country.fullName}>
                {country.fullName}
              </Option>
            ))
          : getPriorityCountries(countries).map((country) => (
              <Option key={country.alpha3Code} value={country.fullName}>
                {country.fullName}
              </Option>
            ))}
      </Select>
    </>
  );

  return (
    <Popover content={content} title='Non-verified country' trigger='click'>
      <Button className='sighting-filter' style={{ width: '10%' }}>
        Non-verified country
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
